import React from 'react';

import { deleteCredentials } from './localStorage';
import { searchStringInObjectArray } from './helpers';

export const parseClientData = data => {
  try {
    const organisationsDictionary = createOrganisationsDictionary(
      data.categories
    );

    const availableReports = Array.isArray(data.reports)
      ? data.reports
          .filter(reportObj => reportObj.props.enableReport === true)
          .map((report, reportIndex) => ({
            ...reportMapping[report.name],
            reportId: report.name,
            reportIndex,
          }))
      : [];

    const defaultReportPath =
      availableReports.length > 0 ? availableReports[0].path : '/';

    const reports = Array.isArray(data.reports)
      ? data.reports.map((report, reportIndex) => {
          const subcategories = Array.isArray(report.subcategories)
            ? data.categories
                .map(category => ({
                  ...category,
                  subcategories: category.subcategories
                    .map(subcategory => ({
                      ...subcategory,
                      categoryIndex: category.categoryIndex,
                      label: subcategory.name,
                      value: subcategory.name,
                    }))
                    .filter(subcategory =>
                      report.subcategories.includes(subcategory.label)
                    )
                    .sort((a, b) => {
                      if (a.label.toLowerCase() < b.label.toLowerCase()) {
                        return -1;
                      } else if (a.label > b.label) {
                        return 1;
                      }
                      return 0;
                    }),
                }))
                .filter(category => category.subcategories.length > 0)
                .sort((a, b) => {
                  if (a.name.toLowerCase() < b.name.toLowerCase()) {
                    return -1;
                  } else if (a.name > b.name) {
                    return 1;
                  }
                  return 0;
                })
                .map((category, categoryIndex) => {
                  const labelWithCount = `${category.name} (${
                    category.subcategories.length
                  })`;

                  const options = (category.subcategories.length > 1
                    ? [
                        {
                          label:
                            data.categories.length === 1
                              ? 'All Subcategories'
                              : `All ${category.name}`,
                          value: category.subcategories
                            .map(item => item.label)
                            .join('|'),
                          categoryIndex: category.value,
                          subcategoryIndex: 0,
                          parentCategory: category.name,
                          organisations: [],
                        },
                      ]
                    : []
                  ).concat(
                    category.subcategories.map(
                      (subcategory, subcategoryIndex) => ({
                        ...subcategory,
                        categoryIndex: category.value,
                        parentCategory: category.name,
                        subcategoryIndex:
                          category.subcategories.length > 1
                            ? subcategoryIndex + 1
                            : subcategoryIndex,
                      })
                    )
                  );

                  return {
                    ...category,
                    label: category.name,
                    labelWithCount,
                    categoryIndex: category.value,
                    options,
                    subcategories: options,
                  };
                })
            : [];

          let reportOrganisationsDictionary = {};
          if (subcategories.lenght > 0) {
            reportOrganisationsDictionary = createOrganisationsDictionary(
              subcategories
            );
          } else if (Array.isArray(report.organisation)) {
            if (report.name !== 'mobileDevices') {
              report.organisation.forEach(org => {
                organisationsDictionary[org].subcategory.parentCategory =
                  organisationsDictionary[org].category.label;
                reportOrganisationsDictionary[org] =
                  organisationsDictionary[org];
              });
            }
          }
          // const reportOrganisationsDictionary = createOrganisationsDictionary();

          const reportSubcategoryDictionary = createSubcategoryDictionary(
            subcategories
          );

          // build the Auidence builder industry options here
          let audienceBuilderIndustryOptions = [];
          audienceBuilderIndustryOptions = subcategories.map(item => {
            const newshift = item.options.concat();

            if (item.options[0].label.includes('All')) {
              newshift.shift();
            }
            item.options = newshift;
            return item;
          });

          return {
            ...report,
            selectOption: {
              label: reportMapping[report.name].name,
              value: reportMapping[report.name].path,
              name: report.name,
              reportIndex,
            },
            defaultInsightType:
              Array.isArray(report.subcategories) &&
              report.subcategories.length > 0
                ? 'category'
                : 'organisation',
            organisationsAvailable:
            report.name === "mobileDevices" ? false
              :Array.isArray(report.organisation) &&
              report.organisation.length > 0,
            categoriesAvailable:
              report.name === 'mobileDevices'
                ? false // Fix for hidding the categories tab shows
                : Array.isArray(report.subcategories) &&
                  report.subcategories.length > 0,
            geographyAvailable: report.geography === true,
            reportOrganisationsDictionary,
            reportSubcategoryDictionary,
            organisation: Array.isArray(report.organisation)
              ? report.organisation
                  .filter(id => {
                    if (organisationsDictionary[id] === undefined) {
                      return false; // skip
                    }
                    return true;
                  })
                  .map(id =>{
                    return  {...organisationsDictionary[id] }
                  })
                  .sort((a, b) => {
                    if (a.label !== undefined && b.label !== undefined) {
                      if (a.label.toLowerCase() < b.label.toLowerCase()) {
                        return -1;
                      } else if (a.label > b.label) {
                        return 1;
                      }
                      return 0;
                    }
                      return 0;

                  })
              : [],
            subcategories,
            audienceBuilderIndustryOptions,
          };
        })
      : [];
    const reportDictionary = {};
    reports.forEach(report => {
      reportDictionary[report.name] = {
        ...report,
      };
    });

    console.log(organisationsDictionary)

    const reportSelectOptions = reports
      .filter(reportObj => reportObj.props.enableReport === true)
      .map(report => ({
        ...report.selectOption,
      }));
    const selectedReport = reportSelectOptions[0];

    const reportLinks = Object.keys(reportMapping)
      // remove mobileDevices from intelligence account Issue #315
      .filter(
        reportId =>
          !(data.accountType === 'intelligence' && reportId === 'mobileDevices')
      )
      .map(reportId => {
        const availableReport =
          Array.isArray(data.reports) &&
          data.reports.find(report => report.name === reportId);
        const available = availableReport
          ? availableReport.props.enableReport
          : false;
        return {
          name: reportMapping[reportId].name,
          id: reportId,
          available,
          path: available ? reportMapping[reportId].path : null,
        };
      });

    // Should change to be this. Wait for green light.
    // const reportLinks = data.reports
    //   .map(reportObject => {
    //     const available = reportObject.props.enableReport;
    //     return {
    //       name: reportMapping[reportObject.name].name,
    //       id: reportObject.name,
    //       available,
    //       path: available ? reportMapping[reportObject.name].path : null,
    //     };
    //   });

    return {
      organisationsDictionary,
      availableReports,
      defaultReportPath,
      reports,
      reportLinks,
      reportDictionary,
      reportSelectOptions,
      selectedReport,
    };
  } catch (error) {
    // if client data has error, clear local storage let user relogin and set error

    deleteCredentials();
    return {
      clientError: true,
    };
  }
};

export const setTravellingPastTitle = (city, suburb, district) => {
  if (city.length === 0 && suburb.length === 0 && district.length === 0) {
    return {
      title: 'New Zealand',
      subtitle: '',
    };
  }
  if (city.length === 1) {
    return {
      title: city[0].name,
      subtitle: `New Zealand > ${city[0].name}`,
    };
  }
  if (city.length > 1) {
    return {
      title: `${city.length} Cities`,
      subtitle: city.map(item => item.name).join(' + '),
    };
  }
  if (suburb.length === 1) {
    return {
      title: suburb[0].name,
      subtitle: `New Zealand > ${suburb[0].name}`,
    };
  }
  if (suburb.length > 1) {
    return {
      title: `${suburb.length} Suburbs`,
      subtitle: suburb.map(item => item.name).join(' + '),
    };
  }
  if (district.length === 1) {
    return {
      title: district[0].name,
      subtitle: `New Zealand > ${district[0].name}`,
    };
  }
  if (district.length > 1) {
    return {
      title: `${district.length} Districts`,
      subtitle: district.map(item => item.name).join(' + '),
    };
  }
  return {
    title: 'New Zealand',
    subtitle: '',
  };
};

// The order of this object controls the order of the links in InsightNavBar via the reports reducer
// Report must be linked to components in the reportFactory function in AppRouter.jsx
export const reportMapping = {
  footfall: {
    name: 'Footfall Insights',
    path: '/footfall-insights',
  },
  travelPast: {
    name: 'Travelling Past Insights',
    path: '/travelling-past-insights',
  },
  home: {
    name: 'Home Insights',
    path: '/home-insights',
  },
  work: {
    name: 'Work Insights',
    path: '/work-insights',
  },
  brandAffinity: {
    name: 'Brand Affinity Insights',
    path: '/brand-affinity-insights',
  },
  mobileDevices: {
    name: 'Mobile Device Insights',
    path: '/mobile-device-insights',
  },
};

export const getFullReportName = report => {
  if (reportMapping[report] && reportMapping[report].name) {
    return reportMapping[report].name;
  }
  return report;
};

export const createOrganisationsDictionary = categories => {

  const organisationsDictionary = {};
  if (Array.isArray(categories)) {
    categories.forEach((category, categoryIndex) => {
      category.value = categoryIndex;
      category.subcategories.forEach((subcategory, subcategoryIndex) => {
        subcategory.organisations.forEach(organisation => {
          organisationsDictionary[organisation.id] = {
            label: organisation.name,
            value: organisation.id,
            category: {
              label: category.name,
              value: category.value,
              categoryIndex: category.value,
            },
            subcategory: {
              label: subcategory.name,
              value: subcategory.name,
              categoryIndex,
            },
            categoryIndex: category.value,
            subcategoryIndex,
            organisationType: organisation.organisationType,
          };
        });
      });
    });
  }
  return organisationsDictionary;
};

export const createSubcategoryDictionary = categories => {
  const subcategoryDictionary = {};
  if (Array.isArray(categories)) {
    categories.forEach((category, categoryIndex) => {
      category.subcategories.forEach((subcategory, subcategoryIndex) => {
        subcategoryDictionary[subcategory.label] = {
          ...subcategory,
          categoryIndex: category.categoryIndex,
          parentCategoryIndex: category.categoryIndex,
          parentCategory: category.name,
          subcategoryIndex,
        };
      });
    });
  }
  return subcategoryDictionary;
};

export const boundaryTierDictionary = {
  AU: {
    COUNTRY: 'Country',
    REGION: 'State',
    DISTRICT: 'Region',
    CITY: 'Major City',
    LOCALITY: 'Suburb',
  },
  NZ: {
    COUNTRY: 'Country',
    REGION: 'Region',
    DISTRICT: 'District',
    CITY: 'Major City',
    LOCALITY: 'Suburb',
  },
};

export const getTierName = (type, boundariesDictionary) => {
  const country =
    boundariesDictionary[0].areas[0].name === 'Australia' ? 'AU' : 'NZ';

  switch (type) {
    case 'country':
      return boundaryTierDictionary[country].COUNTRY;
    case 'region':
      return boundaryTierDictionary[country].REGION;
    case 'district':
      return boundaryTierDictionary[country].DISTRICT;
    case 'city':
      return boundaryTierDictionary[country].CITY;
    case 'locality':
      return boundaryTierDictionary[country].LOCALITY;
    default:
      return '';
  }
};

export const GroupTheBoundaries = (data, type) => {
  let groupedData = {};
  const option = [];
  switch (type) {
    case 'country':
    case 'region':
      // region does not need to be grouped
      data.map(item => option.push({
          label: item.name,
          value: item.id,
        }));
      break;
    case 'district':
    case 'city':
      //run a map to grouping whole data as region
      data.map(item => {
        return groupedData[item.hierarchy.region] === undefined
          ? groupedData[item.hierarchy.region] =
          {
            label: item.hierarchy.region,
            options: [{ label: `${item.name}, ${item.hierarchy.region}`, value: item.id }]
          }
          : groupedData[item.hierarchy.region].options.push({ label: `${item.name}, ${item.hierarchy.region}`, value: item.id });
      })

      // Issue #421 Add one option contain all boundaires.
      groupedData['All'] = {
        label: "All",
        options: [ {label: type ==='district' ? 'All Regional' : 'All Metro' , value: data.map(item => item.id).join() } ]
      }

      //make it as react select option data format
      Object.keys(groupedData).map(item => {
        return option.push(groupedData[item]);
      })

      break;
    case 'locality':
      data.map(item => groupedData[item.hierarchy.place] === undefined
          ? (groupedData[item.hierarchy.place] = {
              label: item.hierarchy.place,
              options: [
                {
                  label: `${item.name}, ${item.hierarchy.place}`,
                  value: item.id,
                },
              ],
            })
          : groupedData[item.hierarchy.place].options.push({
              label: `${item.name}, ${item.hierarchy.place}`,
              value: item.id,
            }));
      Object.keys(groupedData).map(item => option.push(groupedData[item]));
      break;
    case 'pois':
      data.map(item => groupedData[item.hierarchy.place] === undefined
          ? (groupedData[item.hierarchy.place] = {
              label: item.hierarchy.place,
              options: [
                // temp logic for ooh media, only ooh media shows the item.name
                {
                  label: item.displayName,
                  value: item.id,
                  address: item.hierarchy.address,
                  ...item.hierarchy,
                  level: 'poi',
                },
              ],
            })
          : groupedData[item.hierarchy.place].options.push({
              label: item.displayName,
              value: item.id,
              address: item.hierarchy.address,
              ...item.hierarchy,
              level: 'poi',
            }));
      Object.keys(groupedData).map(item => option.push(groupedData[item]));
      break;

    case 'mobileAppsList':
      if (data !== null) {
        data.map(item => {
          // push in to option first
          option.push({
            label: item.name,
            value: item.id,
          });
        });

        option.sort((a, b) => {
          // sort it
          if (a.label.toLowerCase() < b.label.toLowerCase()) {
            return -1;
          } else if (a.label > b.label) {
            return 1;
          }
          return 0;
        });

        return option;
      }
        return [{ label: '', value: '' }];


    default:
      groupedData = { label: '', value: '' };
      break;
  }

  // ordered group name and data alphabetically.
  if (option.length > 0 && option[0].options && option[0].label) {
    option.map(item => item.options.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        } else if (a.label > b.label) {
          return 1;
        }
        return 0;
      }));

    option.sort((a, b) => {
      if (a.label.toLowerCase() < b.label.toLowerCase()) {
        return -1;
      } else if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  }

  return option;
};

export const validateReportCriteria = ({
  insightType,
  report,
  subcategory,
  organisation,
}) => {
  let selectionWarningText = '';
  let selectionWarningButtonText = '';
  let reportCriteriaValid = true;

  if (insightType === null) {
    selectionWarningText = 'Insight type not set';
    selectionWarningButtonText = 'Select an organisation or subcategory';
    reportCriteriaValid = false;
  } else if (insightType === 'category') {
    if (report.categoriesAvailable === false) {
      selectionWarningText = 'Categories are not available on this report';
      selectionWarningButtonText = 'Select an organisation';
      reportCriteriaValid = false;
    } else if (subcategory === null) {
      selectionWarningText = 'Category not set';
      selectionWarningButtonText = 'Select a category';
      reportCriteriaValid = false;
    } else if (
      report.reportSubcategoryDictionary[subcategory.label] === undefined
    ) {
      selectionWarningText =
        'Previously selected subcategory is not available on this report';
      selectionWarningButtonText = 'Select a new subcategory';
      reportCriteriaValid = false;
    }
  } else if (insightType === 'organisation') {
    if (report.organisationsAvailable === false) {
      selectionWarningText = 'Organisations are not available on this report';
      selectionWarningButtonText = 'Select a subcategory';
      reportCriteriaValid = false;
    } else if (organisation === null) {
      selectionWarningText = 'Organisation not set';
      selectionWarningButtonText = 'Select an organisation';
      reportCriteriaValid = false;
    } else if (
      report.reportOrganisationsDictionary[organisation.value] === undefined
    ) {
      selectionWarningText =
        'Previously selected organisation is not available on this report';
      selectionWarningButtonText = 'Select a new organisation';
      reportCriteriaValid = false;
    }
  } else if (insightType === 'geography') {
    if (report.geographyAvailable === false) {
      selectionWarningText = 'Geography is not available on this report';
      selectionWarningButtonText = 'Select an organisation';
      reportCriteriaValid = false;
    }
  }

  return {
    showSelectionWarning: !reportCriteriaValid,
    selectionWarningText,
    selectionWarningButtonText,
  };
};

export const MultiValueLabel = props => {

  switch (props.selectProps.inputId) {
    case 'pois':
      return (
        <div>
          <span className="selected-value">{props.data.label}</span>
          <span className="selected-belong-tag">{props.data.address}</span>
        </div>
      );

    case 'sidebar-select-region':
    case 'apps':
      return (
        <div>
          <span className="selected-value">{props.data.label}</span>
        </div>
      );
    default:
      const separatedPoint = props.data.label.indexOf(',');
      return (
        <div>
          <span className="selected-value">
            {props.data.label.substring(0, separatedPoint)}
          </span>
          <span className="selected-belong-tag">
            {props.data.label.substring(separatedPoint + 2)}
          </span>
        </div>
      );
  }
};

export const formatOptionsLabel = props => (
    <div>
      <div>{props.label}</div>
      <div style={{ fontSize: 12, color: '#697689' }}>{props.address}</div>
    </div>
  );

export const insertTitle = (props, showSelectionWarning) => {
  const {
    insightType,
    organisation,
    subcategory,
    adm0,
    adm2,
    adm3,
    adm4,
    boundariesData,
  } = props;
  const boundaryTypeArray = ['Country', 'Districts', 'Major Cities', 'Suburbs'];
  const foundIndex = [adm0, adm2, adm3, adm4].findIndex(element => element !== null);
  const selectedBoundary = adm0 || adm2 || adm3 || adm4;

  if (showSelectionWarning === true) {
    // if there is a select error, should not show any text
    return ``;
  }

  if (insightType === 'organisation' && organisation) {
    return organisation.label;
  } else if (insightType === 'category' && subcategory) {
    return subcategory.label;
  } else if (insightType === 'geography') {
    if (selectedBoundary === null || selectedBoundary === undefined) {
      // none boundary be choosed
      return boundariesData[0].options[0].label;
    } else if (Array.isArray(selectedBoundary) && selectedBoundary.length > 1) {
      // multiple boundary be choosed
      return `${selectedBoundary.length} ${boundaryTypeArray[foundIndex]}`;
    }
      // only one boundary be choosed
      return selectedBoundary[0].level === 'adm0'
        ? boundariesData[0].options[0].label
        : selectedBoundary[0].label.substring(
            0,
            selectedBoundary[0].label.indexOf(',')
          );

  }
  return ``;
};

export const insertSubTile = (props, showSelectionWarning) => {
  const {
    insightType,
    organisation,
    subcategory,
    adm0,
    adm1,
    adm2,
    adm3,
    adm4,
    poiId,
    boundariesData,
  } = props;
  const boundaryTypeArray = [
    'Country',
    'Region',
    'Districts',
    'Major Cities',
    'Suburbs',
    'Point of interests',
  ];
  const foundIndex = [adm0, adm1, adm2, adm3, adm4, poiId].findIndex(
    element =>
      // find which tier is selected.
       element !== null

  );
  const selectedBoundary = adm0 || adm1 || adm2 || adm3 || adm4 || poiId;

  if (showSelectionWarning === true) {
    // if there is a select error, should not show any text
    return ``;
  }

  if (selectedBoundary === null || selectedBoundary === undefined) {
    // none boundary is choosed
    switch (insightType) {
      case 'organisation':
        return organisation
          ? `${organisation.category.label} > ${
              organisation.subcategory.label
            } > ${organisation.label}`
          : ``;
      case 'category':
        return subcategory
          ? `${subcategory.parentCategory} > ${subcategory.label}`
          : ``;
      case 'geography':
        return ``;
      default:
        return ``;
    }
  } else if (Array.isArray(selectedBoundary) && selectedBoundary.length > 1) {
    // multiple boundary are choosed

    let resultString = '';

    for (let i = 0; i < selectedBoundary.length; i++) {
      if (selectedBoundary[i].label.indexOf(',') > 0) {
        const separatedPoint = selectedBoundary[i].label.indexOf(',');
        resultString +=
          `${selectedBoundary[i].label.substring(0, separatedPoint)  } + `;
      } else {
        resultString += `${selectedBoundary[i].label  } + `;
      }
    }

    switch (insightType) {
      case 'organisation':
      case 'category':
        return `${selectedBoundary.length} ${
          boundaryTypeArray[foundIndex]
        } > ${resultString.substring(0, resultString.length - 2)}`;
      case 'geography':
        return resultString.substring(0, resultString.length - 2);
      default:
        return ``;
    }
  } else {
    // only one boundary is choosed
    const selectedLabel = selectedBoundary[0].label;
    const separatedPoint = selectedLabel.indexOf(',');

    if (
      selectedBoundary[0].level &&
      selectedBoundary[0].level === 'poi' &&
      selectedBoundary[0].place
    ) {
      return `${boundariesData[0].options[0].label} > ${
        selectedBoundary[0].place
      } > ${selectedBoundary[0].label}`;
    }

    if (selectedBoundary[0].level) {
      return (
        selectedBoundary[0].level === 'adm0' &&
        boundariesData[0].options[0].label
      );
    }
      return `${boundariesData[0].options[0].label}
      > ${selectedLabel.substring(separatedPoint + 1, selectedLabel.length)}
        ${foundIndex === 1 ? '' : '>'}
        ${selectedLabel.substring(0, separatedPoint)}
        ${
          selectedBoundary[0].address !== undefined &&
          selectedBoundary[0].address !== null
            ? ` > ${  selectedBoundary[0].address}`
            : ''
        }`;

  }
};

export const insertDigitalSubTitle = (props, showSelectionWarning) => {
  const {
    organisation,
    adm0,
    adm1,
    adm2,
    adm3,
    adm4,
    mobileApp,
    boundariesData,
  } = props;
  const selectedBoundary = adm0 || adm1 || adm2 || adm3 || adm4;
  let mobileCombinationString = '';

  if (showSelectionWarning === true) {
    // if there is a select error, should not show any text
    return ``;
  }

  if (mobileApp !== null) {
    // combinate the mobile app string first.
    for (let i = 0; i < mobileApp.length; i++) {
      mobileCombinationString += `${mobileApp[i].label  } + `;
    }
  }

  if (selectedBoundary === null || selectedBoundary === undefined) {
    // none boundary is choosed

    if (mobileApp === null) {
      return `${organisation.category.label} > ${
        organisation.subcategory.label
      } > ${organisation.label}`;
    }
      return `${boundariesData[0].options[0].label}
    > ${mobileCombinationString.substring(
      0,
      mobileCombinationString.length - 2
    )}`;

  } else if (Array.isArray(selectedBoundary) && selectedBoundary.length > 1) {
    // multiple boundary are choosed

    let resultString = '';

    for (let i = 0; i < selectedBoundary.length; i++) {
      if (selectedBoundary[i].label.indexOf(',') > 0) {
        const separatedPoint = selectedBoundary[i].label.indexOf(',');
        resultString +=
          `${selectedBoundary[i].label.substring(0, separatedPoint)  } + `;
      } else {
        resultString += `${selectedBoundary[i].label  } + `;
      }
    }

    if (mobileApp === null) {
      return resultString.substring(0, resultString.length - 2);
    }
      resultString = resultString.substring(0, resultString.length - 2);
      resultString += ` > ${mobileCombinationString}`;
      return resultString.substring(0, resultString.length - 2);

  }
    // only one boundary is choosed
    const selectedLabel = selectedBoundary[0].label;
    const separatedPoint = selectedLabel.indexOf(',');

    if (mobileApp === null) {
      return `${boundariesData[0].options[0].label}
    > ${selectedLabel.substring(0, separatedPoint)}`;
    }
      return `${boundariesData[0].options[0].label}
      > ${selectedLabel.substring(0, separatedPoint)}
      > ${mobileCombinationString.substring(
        0,
        mobileCombinationString.length - 2
      )}`;


};

export const chooseDownloadableBtn = (
  reportType,
  scopes,
  insightType,
  context
) => {
  const downloadaleBtn = [];
  //
  scopes.forEach(item => {
    if (item.substring(0, item.indexOf('.')).indexOf(reportType) > 0) {
      switch (item.substring(item.indexOf('.') + 1)) {
        case 'customerIDs':
          downloadaleBtn.push({
            id: 'Customer ID',
            value: 'customers',
            fileName: 'CustomerIDs',
          });
          break;
        case 'advertisingIDs':
          downloadaleBtn.push({
            id: 'Advertising ID',
            value: 'devices',
            fileName: 'AdvertisingIDs',
          });
          break;
        // travel past insight
        case 'byHour':
          downloadaleBtn.push({
            id: 'Over time',
            value: 'over-time',
            fileName: 'ByHour',
          });
          break;
        case 'dailyAverages':
          downloadaleBtn.push({
            id: 'Daily averages',
            value: 'daily-averages',
            fileName: 'DailyAverages',
          });
          break;
        case 'POIs':
          downloadaleBtn.push({
            id: 'POIs',
            value: 'pois',
            fileName: 'POIs',
          });
          break;
          // home, work insight
        case 'locations':
          downloadaleBtn.push({
            id: `${reportType.charAt(0).toUpperCase() +
              reportType.slice(1).toLowerCase()} locations`,
            value: 'locations',
            fileName: 'Locations',
          });
          break;
          // brand affinity insight
        case 'brandAffinity':
          downloadaleBtn.push({
            id: 'Brand affinity',
            value: 'brands',
            fileName: 'BrandAffinity',
          });
          break;
        case 'categoryAffinity':
          downloadaleBtn.push({
            id: 'Category affinity',
            value: 'categories',
            fileName: 'CategoryAffinity',
          });
          break;
        case 'topPOIs':
          downloadaleBtn.push({
            id: 'Top POI',
            value: 'top-pois',
            fileName: 'TopPOIs',
          });
          break;

          // mobile divices insight
        case 'installedApps':
          downloadaleBtn.push({
            id: 'Installed apps',
            value: 'apps',
            fileName: 'InstalledApps',
          });
          break;
        case 'deviceBrand':
          downloadaleBtn.push({
            id: 'Device brand',
            value: 'brands',
            fileName: 'DeviceBrand',
          });
          break;
        case 'mobileNetworks':
          downloadaleBtn.push({
            id: 'Mobile network',
            value: 'networks',
            fileName: 'MobileNetworks',
          });
          break;
        case 'ReachAndFrequency':
          if (
            reportType === 'travelPast' &&
            context.selectedPeriod.value === 0
          ) {
            downloadaleBtn.push({
              id: 'Reach and frequency',
              value: 'reach-and-frequency',
              fileName: 'ReachAndFrequency',
            });
          }
          break;
        default:
          break;
      }
    }
  });
  return downloadaleBtn;
};

export const brandAndCategoryNotification = (
  brandArray,
  categoryArray,
  time
) => {
  const resultObj = {};

  resultObj.text = 'Affinity scores meet the confidence interval threshold';

  if (brandArray.length === 0 && categoryArray.length === 0) {
    resultObj.isBrandHaveData = false;
    resultObj.isCategoryHaveData = false;
    time.value === 0
      ? (resultObj.buttonText = 'Make a new selection')
      : (resultObj.buttonText = 'Try selecting a longer time period');
  } else if (brandArray.length === 0 && categoryArray.length !== 0) {
    resultObj.isBrandHaveData = false;
    resultObj.isCategoryHaveData = true;
    resultObj.buttonText = '';
  } else if (brandArray.length !== 0 && categoryArray.length === 0) {
    resultObj.isBrandHaveData = true;
    resultObj.isCategoryHaveData = false;
    resultObj.buttonText = '';
  } else {
    resultObj.isBrandHaveData = true;
    resultObj.isCategoryHaveData = true;
  }

  return resultObj;
};

export const checkDefaultTab = (
  reportsType,
  insightType,
  firstTabAvailable,
  organisationsAvailable
) => {
  let selectedTab = insightType;

  if (firstTabAvailable === false && organisationsAvailable === false) {
    throw new Error('Should not both tab unavailable, check API');
  } else if (firstTabAvailable === false && organisationsAvailable === true) {
    selectedTab = 'organisation';
  } else if (firstTabAvailable === true && organisationsAvailable === false) {
    reportsType === 'footfall'
      ? (selectedTab = 'category')
      : (selectedTab = 'geography');
  } else {
    insightType === 'organisation'
      ? (selectedTab = 'organisation')
      : reportsType === 'footfall'
      ? (selectedTab = 'category')
      : (selectedTab = 'geography');
  }

  return selectedTab;
};


export const isBoundariesBeMultiSelect = (level, array) =>{

  if(array === null || array.length === 0) {
    return true
  }

  switch (level) {
    case 2:
      return !searchStringInObjectArray("All Regional", array, "label");
    case 3:
      return !searchStringInObjectArray("All Metro", array, "label");
    default:
      return true
  }

}




